import React from 'react';

import { Body, Heading } from '@swyftx/aviary/atoms/Typography';

import { useForm } from 'react-hook-form';

import { LoansStepContainer } from './LoansStepContainer';
import { useLoanApplicationService } from '../../xstate/LoanApplication.context';

const GettingStartedStep: React.FC = () => {
  const loanApplicationService = useLoanApplicationService();

  const {
    handleSubmit,
    formState: { isValid },
  } = useForm<any>({
    mode: 'onChange',
  });

  const onSubmit = (data: any) => {
    loanApplicationService.send({ type: 'NEXT', data });
  };

  return (
    <LoansStepContainer customTitle='Before you apply' onSubmit={handleSubmit(onSubmit)} submitDisabled={!isValid}>
      <main className='flex flex-col gap-32'>
        <Body>Here is what you need to know before applying for a loan</Body>

        <div className='flex flex-col gap-8'>
          <Heading size='h6'>What you&apos;ll need:</Heading>
          <ol className='list-outside list-decimal pl-20'>
            <li>
              <Body>
                {/* TODO: font token */}
                <span className='font-semibold'>Loan details:</span> Be ready to share some information about your
                financial situation and how you plan to use the loan. This helps us lend responsibly.
              </Body>
            </li>
            <li>
              <Body>
                <span className='font-semibold'>Crypto security:</span> You will need to provide crypto as security for
                your loan. Whilst you can apply without it, we can&apos;t send your funds until you&apos;ve completed
                this step.
              </Body>
            </li>
          </ol>
        </div>

        <div className='flex flex-col gap-8'>
          <Heading size='h6'>How it works:</Heading>
          <ol className='list-outside list-decimal pl-20'>
            <li>
              <Body>
                <span className='font-semibold'>Submit application:</span> Customise your loan terms and submit your
                application.
              </Body>
            </li>
            <li>
              <Body>
                <span className='font-semibold'>Nominate bank:</span> Deposit $1 to verify where you&apos;d like to
                receive your loan funds.
              </Body>
            </li>
            <li>
              <Body>
                <span className='font-semibold'>Wait for approval:</span> Your loan application is manually reviewed for
                suitability. This can take up to 24 business hours.
              </Body>
            </li>
            <li>
              <Body>
                <span className='font-semibold'>Provide security:</span> If approved, you&apos;ll need to deposit your
                crypto to use as security.
              </Body>
            </li>
            <li>
              <Body>
                <span className='font-semibold'>Receive your funds:</span> We send the funds directly to your nominated
                bank account within 24 hours of security being provided.
              </Body>
            </li>
          </ol>
        </div>
      </main>
    </LoansStepContainer>
  );
};

export { GettingStartedStep };
